<template>
  <div class="history-list" v-if="state.list.length > 0">
    <div class="history-list-title">
      <div class="line"></div>
      <div class="text">{{ $t('product.recentlyViewed') }}</div>
      <div class="line"></div>
    </div>
    <el-carousel :loop="false" :autoplay="false" arrow="always" indicator-position="outside">
      <el-carousel-item v-for="page in state.page" :key="page">
        <div class="item-list">
          <div
            class="item"
            v-for="item in state.list.slice(page * 5 - 5, page * 5)"
            :key="item.id"
            @click="handleClick(item)"
          >
            <img :src="item.goodsImg" />
            <p class="name">
              {{ userStore.language === 'cn' ? item.goodsTitle : item.goodsTitleEn }}
            </p>
            <p class="price">
              {{ userStore.currencyUnit }}
              {{ $flatRateOrigin(item.goodsPrice, userStore.rate) }}
            </p>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script setup lang="ts">
import { getUserBrowsingHistory } from '@/apis/user'
import { useUserStore } from '@/stores'
import { onMounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const userStore = useUserStore()
const $router = useRouter()
const $route = useRoute()
const handleClick = (item) => {
  const id = item.goodsId.slice(2)
  const source = item.source
  if ($route.query.id === id && $route.query.source === source) {
    return
  } else {
    $router.push({ query: { ...$route.query, id, source } })
  }
}
const state = reactive({
  list: [] as any[],
  page: 0,
})
onMounted(() => {
  getUserBrowsingHistory().then((res) => {
    state.page = Math.ceil(res.length / 5)
    state.list = res
  })
  state
})
</script>

<style lang="scss" scoped>
.history-list {
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;

  .history-list-title {
    font-size: 18px;
    font-weight: bold;
    color: var(--gray-color-84);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .text {
      white-space: nowrap;
      padding: 0 70px;
    }

    .line {
      width: 100%;
      height: 1px;
      background: var(--gray-color-84);
      flex-flow: 1;
    }
  }

  :deep(.el-carousel) {
    overflow: inherit;

    .el-carousel__container {
      height: 340px;
    }

    .el-carousel__indicators {
      display: none;
    }

    .el-carousel__container {
      overflow: hidden;
    }

    .el-carousel__arrow--left {
      top: 130px;
      left: -60px;
    }

    .el-carousel__arrow--right {
      top: 130px;
      right: -60px;
    }
  }

  .item-list {
    display: flex;
    gap: 20px;

    .item {
      width: 248px;

      img {
        border-radius: 12px;
        width: 248px;
        height: 248px;
        margin-bottom: 16px;
      }

      .name {
        font-size: 14px;
        color: var(--black-color-9);
        margin-bottom: 16px;
        height: 40px;
        width: 248px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .price {
        font-size: 18px;
        font-weight: bold;
        color: var(--primary-color);
      }
    }
  }
}
</style>
